/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Ghassen Ben Nasser | Software & AI Engineer",
  description:
    "Software & AI engineer specializing in reliable intelligent systems, multi-tenant chatbots, and data-driven web/mobile products.",
  og: {
    title: "Ghassen Ben Nasser Portfolio",
    type: "website",
    url:
      "https://www.upwork.com/freelancers/~01c478e58397349986?mp_source=share",
  },
};

//Home Page
const greeting = {
  title: "Ghassen Ben Nasser",
  logo_name: "GhassenBenNasser",
  nickname: "Software & AI Engineer",
  subTitle:
    "Software engineer specializing in AI, focused on reliable, intelligent systems across chatbots, data products, and full-stack web/mobile solutions.",
  resumeLink: "/cv_Ghassen_Ben_Nasser_en_latest.pdf",
  portfolio_repository: "https://github.com/Ghassen-Ben-Nasser/masterPortfolio",
  githubProfile: "https://github.com/Ghassen-Ben-Nasser",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/Ghassen-Ben-Nasser",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
    className: "fa-brands",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ghassen-ben-nasser-4193681b9/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
    className: "fa-brands",
  },
  {
    name: "Email",
    link: "mailto:ghassennasser8@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
    className: "fa-brands",
  },
  {
    name: "Upwork",
    link:
      "https://www.upwork.com/freelancers/~01c478e58397349986?mp_source=share",
    fontAwesomeIcon: "fa-briefcase", // Font Awesome Brands icon for Upwork
    iconifyClassname: "simple-icons:upwork", // Fallback if FA icon fails
    backgroundColor: "#6fda44",
    className: "fa",
  },
];

const skills = {
  data: [
    {
      title: "Software & AI Engineering",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building multi-tenant, RAG-powered chatbots with secure tenant isolation, graph knowledge bases, and custom business logic",
        "⚡ Delivering computer vision and NLP features for production apps using TensorFlow, OpenCV, and LLM-powered workflows",
        "⚡ Designing data pipelines and APIs that keep conversational and analytical systems updated in real time",
      ],
      softwareSkills: [
        {
          skillName: "C / C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#00599C",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "simple-icons:opencv",
          style: {
            color: "#5C3EE8",
          },
        },
        {
          skillName: "Neo4j",
          fontAwesomeClassname: "simple-icons:neo4j",
          style: {
            color: "#008CC1",
          },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: {
            color: "#0C4B33",
          },
        },
        {
          skillName: "OpenAI",
          fontAwesomeClassname: "simple-icons:openai",
          style: {
            color: "#412991",
          },
        },
      ],
    },
    {
      title: "Full Stack & Mobile Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive web apps with React.js, Vue.js, and custom component libraries",
        "⚡ Developing cross-platform mobile apps with React Native and Expo, from MVP to store releases",
        "⚡ Creating REST APIs with Node.js/Express and integrating authentication, payments, and real-time messaging",
      ],
      softwareSkills: [
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: {
            color: "#3178C6",
          },
        },
        {
          skillName: "React",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Vue.js",
          fontAwesomeClassname: "simple-icons:vuedotjs",
          style: {
            color: "#42b883",
          },
        },
        {
          skillName: "React Native",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#83CD29",
          },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
      ],
    },
    {
      title: "Cloud, Web3 & Platforms",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Deploying and scaling workloads on AWS Lambda/EC2, OVH, and IONOS with secure networking and monitoring",
        "⚡ Building web3 payment flows with token selection, wallet integrations, and on-chain event validation",
        "⚡ Managing document and media workflows across DynamoDB, MongoDB, S3, and Firebase",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "OVH",
          fontAwesomeClassname: "simple-icons:ovh",
          style: {
            color: "#123F6D",
          },
        },
        {
          skillName: "IONOS",
          fontAwesomeClassname: "simple-icons:ionos",
          style: {
            color: "#003666",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Solidity",
          fontAwesomeClassname: "simple-icons:solidity",
          style: {
            color: "#2c2c2c",
          },
        },
        {
          skillName: "DynamoDB",
          fontAwesomeClassname: "simple-icons:amazondynamodb",
          style: {
            color: "#4053D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    // Add competitive programming profiles here when available.
  ],
};

const degrees = {
  degrees: [
    {
      title: "National School of Computer Science (ENSI)",
      subtitle: "B.Sc. in Computer Engineering, AI specialization",
      logo_path: "education.svg",
      alt_name: "ENSI",
      duration: "2022/09 - 2025/06",
      descriptions: [
        "⚡ Specialized in artificial intelligence with a focus on data science and machine learning projects.",
        "⚡ Delivered applied research and product work in AI chatbots, computer vision, and intelligent systems.",
      ],
      website_link: "https://ensi.rnu.tn/",
    },
    {
      title: "Preparatory Institute for Engineering Studies of Tunis (IPEIT)",
      subtitle: "Preparatory cycle for engineering studies",
      logo_path: "education.svg",
      alt_name: "IPEIT",
      duration: "2020/09 - 2022/06",
      descriptions: [
        "⚡ Completed intensive preparatory curriculum for engineering studies, strengthening math, physics, and CS fundamentals.",
      ],
      website_link: "http://www.ipeit.rnu.tn",
    },
  ],
};

const certifications = {
  // Add relevant certifications here when available.
  certifications: [],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work & Internships",
  description:
    "Software & AI engineer delivering production-ready chatbots, cloud-first platforms, and mobile/web products with measurable business impact.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Software & AI Engineer (Freelance)",
          company: "Private Client (Germany)",
          company_url:
            "https://www.linkedin.com/in/ghassen-ben-nasser-4193681b9/",
          logo_path: "experience.svg",
          duration: "Jun 2025 - Present",
          location: "Germany (remote)",
          description:
            "Continued full-time on a freelance contract after completing my end-of-studies internship with the same German client in June 2025. Built the Chatbot Widget Agent to read, add, and update knowledge securely; implemented RAG pipelines with Neo4j and delivered ERP workflows for orders, offers, products, and stock with controlled business logic.",
          color: "#000000",
        },
        {
          title: "Software & AI Engineer",
          company: "Bright Soft Sarl",
          company_url:
            "https://www.linkedin.com/in/ghassen-ben-nasser-4193681b9/",
          logo_path: "projects_image.svg",
          duration: "Feb 2023 - Feb 2025",
          location: "Siliana, Tunisia",
          description:
            "Delivered document platforms and mobile features, including PDF tooling, real-time logistics flows, and marketplace capabilities across web and mobile stacks.",
          color: "#0a81c4",
        },
        {
          title: "Mobile Developer",
          company: "Greencard SA",
          company_url:
            "https://www.linkedin.com/in/ghassen-ben-nasser-4193681b9/",
          logo_path: "developerActivity.svg",
          duration: "Jul 2022 - Jan 2023",
          location: "Jeddah, Saudi Arabia",
          description:
            "Built and deployed cross-platform mobile app releases with React Native and Expo, ensuring smooth delivery to Android and iOS stores.",
          color: "#1f8acb",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "End-of-Studies Intern",
          company: "Private Client",
          company_url:
            "https://www.linkedin.com/in/ghassen-ben-nasser-4193681b9/",
          logo_path: "experience.svg",
          duration: "Feb 2025 - Jun 2025",
          location: "Berlin, Germany (remote)",
          description:
            "Developed a multi-tenant AI chatbot platform with RAG (Neo4j), secure tenant isolation, embeddable widgets, and custom business logic plus API integrations.",
          color: "#000000",
        },
        {
          title: "Summer Intern - PDF Platform",
          company: "Bright Soft Sarl",
          company_url:
            "https://www.linkedin.com/in/ghassen-ben-nasser-4193681b9/",
          logo_path: "projects_image.svg",
          duration: "Jun 2024 - Sep 2024",
          location: "Siliana, Tunisia",
          description:
            "Designed and built 20+ PDF tools for merging, splitting, protecting, signing, and compressing documents; deployed on AWS Lambda/EC2 for scale.",
          color: "#0a81c4",
        },
        {
          title: "Summer Intern - Logistics & Bidding",
          company: "Bright Soft Sarl",
          company_url:
            "https://www.linkedin.com/in/ghassen-ben-nasser-4193681b9/",
          logo_path: "projects_image.svg",
          duration: "Jun 2023 - Aug 2023",
          location: "Siliana, Tunisia",
          description:
            "Built real-time tracking features and impartial bidding logic for a logistics application using React Native, Symfony, MySQL, and AWS EC2.",
          color: "#0a81c4",
        },
      ],
    },
    // {
    //   title: "Volunteerships",
    //   experiences: [
    //     // Add community and volunteer highlights when available.
    //   ],
    // },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Selected work across AI chatbots, web3 payments, e-commerce, PDF tooling, and mobile applications. Most solutions are production-deployed with cloud and data integrations.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Articles, talks, and research will be added when available.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [],
};

// Personal Info - languages, profile summary, and other CV details
// Keep this in sync with the CV to ensure the chatbot can answer accurately.
const personalInfo = {
  profile:
    "Software Engineer specializing in Artificial Intelligence, with a strong interest in building reliable and intelligent systems. Passionate about data science and machine learning.",
  languages: [
    { language: "Arabic", level: "Native" },
    { language: "English", level: "Native" },
    { language: "French", level: "Fluent" },
  ],
  programmingLanguages: ["JavaScript", "C", "C++", "Python", "Java", "PHP"],
  availability:
    "Open to freelance projects and full-time remote opportunities.",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "ghassen_image.png",
    description:
      "Available for AI chatbot builds, full-stack products, and mobile apps. Reach me at ghassennasser8@gmail.com or call +216 25196911.",
  },
  blogSection: {
    title: "Ghassen Ben Nasser",
    subtitle:
      "Visit my Upwork profile for availability, rates, and client-ready project packages.",
    link:
      "https://www.upwork.com/freelancers/~01c478e58397349986?mp_source=share",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Location",
    subtitle: "Manouba, Tunisia",
    locality: "Manouba",
    country: "Tunisia",
    region: "Manouba",
    postalCode: "",
    streetAddress: "",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Manouba,+Tunisia",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+21625196911",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  personalInfo,
};
